import CODE from "@/locales/KOR.json";
import _ from "lodash";
import { encode, decode } from "html-entities";
import LoadingPlugin from "vue-loading-overlay";

export default {
  install(Vue) {
    /**
     * 계약기간을 구분값에 따라 다국어처리하여 리턴한다.
     * @param String ctrcUnitDstcd
     * @return String strMsg
     */
    Vue.prototype.$ctrcUnitDstcd = function(code) {
      let msgCode = "";
      switch (code) {
        case "D": // 계약기간(일)
          msgCode = "MCOM-0000118";
          break;
        case "M": // 계약기간(월)
          msgCode = "MCOM-0000119";
          break;
        case "W": // 계약기간(주)
          msgCode = "MCOM-0000120";
          break;
        case "Y": // 계약기간(년)
          msgCode = "MCOM-0000121";
          break;
        default:
          // 계약기간
          msgCode = "MCOM-0000117";
      }
      return msgCode;
    };

    /**
     * 계약기간을 구분값에 따른 타입을 다국어처리하여 리턴한다.
     * @param String ctrcUnitDstcd
     * @return String strMsg
     */
    Vue.prototype.$ctrcUnitDstcdType = function(code) {
      let msgCode = "";
      switch (code) {
        case "D": // 일
          msgCode = "MCOM-0000113";
          break;
        case "M": // 개월
          msgCode = "MCOM-0000110";
          break;
        case "W": // 주
          msgCode = "MCOM-0000111";
          break;
        case "Y": // 년
          msgCode = "MCOM-0000112";
          break;
      }
      return msgCode;
    };

    /**
     * 출금계좌번호 특수문자 삭제 하기 .
     * @param String orgAcn
     * @return String strOrgAcn
     */
    Vue.prototype.$removeAcn = function(orgAcn) {
      let strOrgAcn = "";

      //null 이거나 값이 없을 경우.
      if (orgAcn == undefined || orgAcn == "") {
        return "";
      }

      let tempOrgAcn = [];
      tempOrgAcn = orgAcn.split(""); //배열로.

      for (const key in tempOrgAcn) {
        if (tempOrgAcn[key] != "-" && tempOrgAcn[key] != "," && tempOrgAcn[key] != "/" && tempOrgAcn[key] != ")") {
          strOrgAcn += tempOrgAcn[key];
        }
      }
      return strOrgAcn.toString();
    };

    /**
     * 조회 시작일과 종료일이 최근 n개월 안에 있는지 체크
     */
    Vue.prototype.$inDurationMonth = function(startDate, endDate, term) {
      if (startDate.length == "8" && endDate.length == "8") {
        let endDateObj = "";
        let strFrom = "";
        let strYear = "";
        let strMonth = "";
        let strDate = "";
        let strValue = "";

        // 조회종료일
        endDateObj = new Date(endDate.substring(0, 4), Number(endDate.substring(4, 6)) - 1, endDate.substring(6, 8));

        strDate = endDateObj.getDate();

        // 넘겨받은 개월수를 뺀다.
        strFrom = endDateObj.getMonth() - term;
        endDateObj.setMonth(strFrom);

        // 인뱅기준 날짜에 1을 더한다.
        strFrom = endDateObj.getDate() + 1;
        endDateObj.setDate(strFrom);

        if (
          (strDate == 31 && endDateObj.getDate() > 1) ||
          (strDate == 30 && endDateObj.getDate() != 31 && endDateObj.getDate() > 1) ||
          (strDate == 29 && endDateObj.getDate() < 30 && endDateObj.getDate() > 1) ||
          (strDate == 28 && endDateObj.getDate() < 29 && endDateObj.getDate() > 1)
        ) {
          endDateObj.setDate(1);
        }

        strYear = String(endDateObj.getFullYear()); // 년
        strMonth = String(endDateObj.getMonth() + 1); // 월
        strDate = String(endDateObj.getDate()); // 일

        // 월이 한자리수면 앞에 0을 붙인다.
        if (strMonth.length == "1") {
          strMonth = "0" + strMonth;
        }

        // 일이 한자리수면 앞에 0을 붙인다.
        if (strDate.length == "1") {
          strDate = "0" + strDate;
        }

        // 조회종료일로부터 term개월 만큼 뺀 일자.
        strValue = strYear + strMonth + strDate;

        // 조회시작일이 조회종료일로부터 term개월 만큼뺀 일자 보다 작으면  false를 반환.
        if (Number(startDate) < Number(strValue)) {
          return false;
        }

        return true;
      }
    };

    /**
     * 다국어 JSON에서 코드값 기준으로 리스트 뽑아오기
     * @param String code name
     * @param Number code filter from
     * @param Number code filter to
     * ex) 01_송금목적구분 ---> $codeList('송금목적구분')
     */
    Vue.prototype.$codeList = function(code, from, to) {
      let data = [];
      let tmp = [];

      for (let key in CODE) {
        if (_.endsWith(key, `_${code}`)) {
          data.push({ text: key, value: key.split("_")[0] });
        }
      }
      //filter
      if (from !== undefined && to !== undefined) {
        for (let key of data) {
          if (Number(key.value) >= from && key.value <= to) {
            tmp.push(key);
          }
        }
        data = tmp;
      }
      return data;
    };

    /**
     * 문자열 길이의 짝수여부 체크
     * 파라미터로 받은 문자열의 길이가 짝수인지 홀수인지 체크한다.
     * @param String str : 마스킹 처리대상 문자열
     * @return boolean : true : 짝수, false : 홀수
     */
    Vue.prototype.$isEven = function(str) {
      let strLength = 0; //	문자열 길이 변수
      if (str == null) return false; //	문자열 변수가 NULL일 경우 false 리턴
      if (str == "") return true; //	문자열이 공백일 경우 true 리턴(0이므로)

      strLength = str.length; //	문자열 길이 담기
      if (strLength % 2 == 0) return true; //	길이값을 2로 나눠서 나온 나머지 값이 0이면 짝수이므로 true 리턴

      return false; //	그 외에는 false 리턴
    };

    /**
     * 아이디 마스킹
     * 뒤 3,4,5자리 마스킹 처리
     * @param String str : 마스킹 처리대상 문자열[아이디]
     * @return String : 마스킹 처리된 문자열[ex) KIMKOOKMIN --> KIMKO***IN]
     */
    Vue.prototype.$maskId = function(str) {
      let replaceStr = ""; //	리턴용 let 변수
      let strLength = 0; //	문자열 길이 변수
      if (str == null) return null; //	문자열 변수가 NULL일 경우 false 리턴
      if (str == "") return ""; //	문자열이 공백일 경우 true 리턴(0이므로)

      strLength = str.length; //	문자열 길이 담기
      if (strLength >= 5) {
        //	5자리 이상의 문자열일 경우
        replaceStr += str.substring(0, strLength - 5); //	마스킹 데이터 앞(첫번째 자리 ~ 끝 6번째 자리) 문자열 넣기
        replaceStr += Vue.prototype.$config.MASKING_WORD + Vue.prototype.$config.MASKING_WORD + Vue.prototype.$config.MASKING_WORD; //	마스킹 문자열 넣기
        replaceStr += str.substring(strLength - 2, strLength); //	마스킹 데이터 뒤 문자열 넣기(끝 2번째 자리 ~ 마지막 자리)
      } else {
        //	5자리 미만의 문자열이면 마스킹처리하지 않음
        replaceStr += str;
      }

      return replaceStr.toString(); //	let를 문자열형으로 리턴
    };

    /**
     * 고객명 마스킹
     * 길이가 홀수인 경우 짝수자리를, 짝수인 3째자리부터 홀수자리수의 문자를 마스킹처리한다.(스페이스도 문자열로 간주)
     * @param String str : 마스킹 처리대상 문자열[고객명]
     * @return String : 마스킹 처리된 문자열[ex) 홍길동 --> 홍*동]
     */
    Vue.prototype.$maskName = function(str) {
      let replaceStr = ""; //	리턴용 let 변수
      let strLength = 0; //	문자열 길이 변수
      if (str == null) return null; //	문자열 변수가 NULL일 경우 false 리턴
      if (str == "") return ""; //	문자열이 공백일 경우 true 리턴(0이므로)

      strLength = str.length; //	문자열 길이 담기
      if (Vue.prototype.$isEven(str)) {
        //	문자열 길이가 짝수일 경우
        for (let i = 0; i < strLength; i++) {
          if (i >= 2 && i % 2 == 0) {
            //	문자열의 index가 2 이상이고(3째자리부터), index가 짝수일 경우(사용자가 보기에는 홀수자리수) 마스킹 처리
            replaceStr += Vue.prototype.$config.MASKING_WORD;
          } else {
            //	그 외에는 해당 index의 문자를 그대로 처리
            replaceStr += str.charAt(i);
          }
        }
      } else {
        //	문자열 길이가 홀수일 경우
        for (let i = 0; i < strLength; i++) {
          if (i % 2 != 0) {
            //	index가 홀수일 경우(사용자가 보기에는 짝수자리수) 마스킹 처리
            replaceStr += Vue.prototype.$config.MASKING_WORD;
          } else {
            //	그 외에는 해당 index의 문자를 그대로 처리
            replaceStr += str.charAt(i);
          }
        }
      }

      return replaceStr.toString();
    };

    /**
     * 고객식별번호 마스킹
     * 뒤의 6자리 마스킹처리
     * @param String str : 마스킹 처리대상 문자열[고객식별번호]
     * @return String : 마스킹 처리된 문자열[ex) 888888-2222222 --> 888888-2******]
     */
    Vue.prototype.$maskUserNo = function(str) {
      let replaceStr = ""; //	리턴용 let 변수
      let strLength = 0; //	문자열 길이 변수
      if (str == null) return null; //	문자열 변수가 NULL일 경우 false 리턴
      if (str == "") return ""; //	문자열이 공백일 경우 true 리턴(0이므로)

      strLength = str.length; //	문자열 길이 담기
      if (strLength == 13 || strLength == 14) {
        //	문자열 길이가 13자리이거나 14자리(하이픈 추가)일 경우 주민등록번호
        replaceStr += str.substring(0, strLength - 6); //	마스킹 데이터 앞(첫번째 자리 ~ 끝 7[혹은 8]번째 자리) 문자열 넣기
        replaceStr += Vue.prototype.$config.MASKING_WORD + Vue.prototype.$config.MASKING_WORD + Vue.prototype.$config.MASKING_WORD; //	마스킹 문자열 넣기
        replaceStr += Vue.prototype.$config.MASKING_WORD + Vue.prototype.$config.MASKING_WORD + Vue.prototype.$config.MASKING_WORD; //	마스킹 문자열 넣기
      } else {
        //	문자열 길이가 해당하지 않을경우 마스킹 처리 안함
        replaceStr += str;
      }
      return replaceStr.toString();
    };

    /**
     * 이메일주소 마스킹
     * @ 앞 3자리 마스킹처리(단, webmaster 같은 공개용 제외)
     * @param String str : 마스킹 처리대상 문자열[이메일주소]
     * @return String : 마스킹 처리된 문자열[ex) dan123@gmail.com --> dan***@gmail.com]
     */
    Vue.prototype.$maskEmail = function(str) {
      let replaceStr = ""; //	리턴용 let 변수
      let strLength = 0; //	문자열 길이 변수
      let LastIndexOfAt = 0; //	문자열에서 @의 마지막 위치 index
      if (str == null) return null; //	문자열 변수가 NULL일 경우 false 리턴
      if (str == "") return ""; //	문자열이 공백일 경우 true 리턴(0이므로)

      strLength = str.length; //	문자열 길이 담기

      if (str.lastIndexOf("@") > 0 && str.lastIndexOf(".") > 0) {
        //	@와 .이 문자열 내에 있을 경우(올바른 이메일 형식일 경우)
        LastIndexOfAt = str.lastIndexOf("@");
        let EmailId = str.substring(0, LastIndexOfAt); //	E-Mail의 ID부분(@의 앞부분) 추출
        for (let i = 0; i < Vue.prototype.$config.NO_MASK_EMAIL_ARR.length; i++) {
          if (EmailId == Vue.prototype.$config.NO_MASK_EMAIL_ARR[i]) {
            //	마스킹 비처리 대상일 경우
            replaceStr += str; //	마스킹 처리하지않고 그대로 let에 저장
            return replaceStr.toString(); //	return
          }
        }
        if (LastIndexOfAt > 3) {
          //	@의 index가 3 이상일 경우
          replaceStr += str.substring(0, LastIndexOfAt - 3); //	마스킹 데이터 앞(첫번째 자리 ~ 마지막 @의 위치에서부터 앞 3자리) 문자열 넣기
          replaceStr += Vue.prototype.$config.MASKING_WORD + Vue.prototype.$config.MASKING_WORD + Vue.prototype.$config.MASKING_WORD; //	마스킹 문자열 넣기
          replaceStr += str.substring(LastIndexOfAt, strLength); //	마스킹 데이터 뒤(@ 부터 도메인부) 문자열 넣기
        } else {
          //	@의 index가 2 이하일 경우
          for (let i = 0; i < LastIndexOfAt; i++) {
            replaceStr += Vue.prototype.$config.MASKING_WORD; //	마스킹 문자열 넣기
          }
          replaceStr += str.substring(LastIndexOfAt, strLength); //	마스킹 데이터 뒤(@ 부터 도메인부) 문자열 넣기
        }
      } else {
        replaceStr += str;
      }
      return replaceStr.toString();
    };

    /**
     * 카드번호 마스킹
     * before : 가운데 8자리 마스킹, after : 앞 7,8,9,10,11,12자리 마스킹
     * @param String str : 마스킹 처리대상 문자열[카드번호]
     * @return String : 마스킹 처리된 문자열[ex) 7894 2346 6785 6513 --> 7894 23** **** 6513]
     */
    Vue.prototype.$maskCardNo = function(str) {
      let replaceStr = ""; //	리턴용 let 변수
      let strLength = 0; //	문자열 길이 변수
      if (str == null) return null; //	문자열 변수가 NULL일 경우 false 리턴
      if (str == "") return ""; //	문자열이 공백일 경우 true 리턴(0이므로)  -- 해당부분 수정.

      strLength = str.length; //	문자열 길이 담기

      if (strLength == 16 || strLength == 19) {
        //	문자열 길이가 12자리 혹은 15자리(하이픈or공백 포함)일 경우 마스킹 처리대상
        replaceStr += str.substring(0, 4); //	첫 카드번호 4자리 셋팅
        replaceStr += "-"; //	카드번호 구분용 하이픈
        if (strLength == 16) {
          replaceStr += str.substring(4, 6); //	카드번호 5~6자리 셋팅
        } else {
          replaceStr += str.substring(5, 7); //	카드번호 5~6자리 셋팅
        }
        replaceStr += Vue.prototype.$config.MASKING_WORD + Vue.prototype.$config.MASKING_WORD; //	마스킹 문자열 넣기
        replaceStr += "-"; //	카드번호 구분용 하이픈
        replaceStr += Vue.prototype.$config.MASKING_WORD + Vue.prototype.$config.MASKING_WORD + Vue.prototype.$config.MASKING_WORD + Vue.prototype.$config.MASKING_WORD; //	마스킹 문자열 넣기
        replaceStr += "-"; //	카드번호 구분용 하이픈
        replaceStr += str.substring(strLength - 4, strLength); //	첫 카드번호 4자리 셋팅
      } else {
        replaceStr += str;
      }
      return replaceStr.toString();
    };

    /**
     * 계좌번호 마스킹
     * before : 뒤에 4자리 마스킹, after : 뒤에서 4,5,6번째자리 마스킹
     * @param String str : 마스킹 처리대상 문자열[계좌번호]
     * @return String : 마스킹 처리된 문자열[ex) 789789798546461234 --> 789789798546***234]
     */
    Vue.prototype.$maskAccNo = function(str) {
      let replaceStr = ""; //	리턴용 let 변수
      let strLength = 0; //	문자열 길이 변수
      if (str == null) return null; //	문자열 변수가 NULL일 경우 false 리턴
      if (str == "") return ""; //	문자열이 공백일 경우 true 리턴(0이므로)

      strLength = str.length; //	문자열 길이 담기

      if (strLength > 4) {
        replaceStr += str.substring(0, strLength - 6); //	마스킹 비대상 문자열 넣기(첫번째자리부터 끝에서 7번째자리까지)
        replaceStr += Vue.prototype.$config.MASKING_WORD + Vue.prototype.$config.MASKING_WORD + Vue.prototype.$config.MASKING_WORD; //	마스킹 문자열 넣기
        replaceStr += str.substring(strLength - 3, strLength); //	마스킹 비대상 문자열 넣기(끝에서 3번째자리부터 끝자리까지)
      } else {
        replaceStr += str;
      }
      return replaceStr.toString();
    };

    /**
     * MMQR 계좌번호 마스킹
     * @param String str : 마스킹 처리대상 문자열[계좌번호]
     * @return String : 마스킹 처리된 문자열[ex) 789789798541234 --> 789789*****1234]
     */
    Vue.prototype.$maskAccNoByMMQR = function(str) {
    
      let replaceStr = ""; //	리턴용 let 변수
      let strLength = 0; //	문자열 길이 변수
      if (str == null) return null; //	문자열 변수가 NULL일 경우 false 리턴
      if (str == "") return ""; //	문자열이 공백일 경우 true 리턴(0이므로)

      strLength = str.length; //	문자열 길이 담기
 
      if (strLength > 4) {
        replaceStr += str.substring(0, strLength - 9);
        replaceStr += Vue.prototype.$config.MASKING_WORD + Vue.prototype.$config.MASKING_WORD + Vue.prototype.$config.MASKING_WORD 
        replaceStr += Vue.prototype.$config.MASKING_WORD + Vue.prototype.$config.MASKING_WORD;
        replaceStr += str.substring(strLength - 4, strLength);
      } else {
        replaceStr += str;
      }
      return replaceStr.toString();
    };


    /**
     * 비밀번호 마스킹
     * 입력시 모두 마스킹
     * @param String str : 마스킹 처리대상 문자열[비밀번호]
     * @return String : 마스킹 처리된 문자열[ex) 1234 --> ****]
     */
    Vue.prototype.$maskPassword = function(str) {
      let replaceStr = ""; //	리턴용 let 변수
      let strLength = 0; //	문자열 길이 변수
      if (str == null) return null; //	문자열 변수가 NULL일 경우 false 리턴
      if (str == "") return ""; //	문자열이 공백일 경우 true 리턴(0이므로)

      strLength = str.length; //	문자열 길이 담기

      for (let i = 0; i < strLength; i++) {
        replaceStr += Vue.prototype.$config.MASKING_WORD; //	문자열 길이만큼 마스킹 문자열 넣기
      }

      return replaceStr.toString();
    };

    /**
     * 전화번호 마스킹
     * 뒤에서 6,7,8,9자리 마스킹(하이픈에 상관없이)
     * @param String str : 마스킹 처리대상 문자열[전화번호]
     * @return String : 마스킹 처리된 문자열
     */
    Vue.prototype.$maskPhone = function(str) {
      let replaceStr = ""; //	리턴용 let 변수
      let strLength = 0; //	문자열 길이 변수
      let i = 0;
      let strAsterik = "";

      if (str == null) return null; //	문자열 변수가 NULL일 경우 false 리턴
      if (str == "") return ""; //	문자열이 공백일 경우 true 리턴(0이므로)

      strLength = str.length; //	문자열 길이 담기
      if (strLength >= 9) {
        i = 9;
        strAsterik = Vue.prototype.$config.MASKING_WORD + Vue.prototype.$config.MASKING_WORD + Vue.prototype.$config.MASKING_WORD + Vue.prototype.$config.MASKING_WORD;
      } else if (strLength == 8) {
        i = 8;
        strAsterik = Vue.prototype.$config.MASKING_WORD + Vue.prototype.$config.MASKING_WORD + Vue.prototype.$config.MASKING_WORD;
      } else if (strLength == 7) {
        i = 7;
        strAsterik = Vue.prototype.$config.MASKING_WORD + Vue.prototype.$config.MASKING_WORD;
      } else if (strLength == 6) {
        i = 6;
        strAsterik = Vue.prototype.$config.MASKING_WORD;
      }

      if (strLength >= 6) {
        replaceStr += str.substring(0, strLength - i); //	마스킹 데이터 앞(첫번째 자리 ~ 끝 10번째 자리) 문자열 넣기
        replaceStr += strAsterik; //	마스킹 문자열 넣기
        replaceStr += str.substring(strLength - 5, strLength); //	마스킹 데이터 뒤 문자열 넣기(끝 5번째 자리 ~ 마지막 자리)

        // 			replaceStr+=str.substring(0, strLength-9));			//	마스킹 데이터 앞(첫번째 자리 ~ 끝 10번째 자리) 문자열 넣기
        // 			replaceStr+=Vue.prototype.$config.MASKING_WORD+Vue.prototype.$config.MASKING_WORD+Vue.prototype.$config.MASKING_WORD+Vue.prototype.$config.MASKING_WORD);		//	마스킹 문자열 넣기
        // 			replaceStr+=str.substring(strLength-5, strLength));	//	마스킹 데이터 뒤 문자열 넣기(끝 5번째 자리 ~ 마지막 자리)
      } else {
        //	9자리 미만의 문자열이면 마스킹처리하지 않음
        replaceStr += str;
      }

      return replaceStr.toString(); //	let를 문자열형으로 리턴
    };

    /**
     * IP주소 마스킹
     * 세번째 칸 주소부 마스킹 처리
     * @param String str : 마스킹 처리대상 문자열[IP주소]
     * @return String : 마스킹 처리된 문자열[ex) 123.456.789.012 --> 123.456.***.012]
     */
    Vue.prototype.$maskIp = function(str) {
      let replaceStr = ""; //	리턴용 let 변수
      let strLength = 0; //	문자열 길이 변수
      let startMaskIndex = 0; //	마스크 시작 위치
      let endMaskIndex = 0; //	마스크 종료 위치
      if (str == null) return null; //	문자열 변수가 NULL일 경우 false 리턴
      if (str == "") return ""; //	문자열이 공백일 경우 true 리턴(0이므로)

      strLength = str.length; //	문자열 길이 담기
      startMaskIndex = str.indexOf(".", str.indexOf(".") + 1); //	세번째 칸 주소부 시작점 찾기
      endMaskIndex = str.indexOf(".", startMaskIndex + 1); //	세번째 칸 주소부 끝점 찾기

      if (startMaskIndex > -1 && endMaskIndex > -1 && startMaskIndex < endMaskIndex) {
        replaceStr += str.substring(0, startMaskIndex + 1); //	마스킹 데이터 앞(첫번째 자리 ~ 두번째 점) 문자열 넣기
        for (let i = 0; i < endMaskIndex - startMaskIndex - 1; i++) {
          replaceStr += Vue.prototype.$config.MASKING_WORD;
        }
        replaceStr += str.substring(endMaskIndex, strLength); //	마스킹 데이터 뒤(세번째 점 ~ 문자열 끝) 문자열 넣기
      } else {
        //	9자리 미만의 문자열이면 마스킹처리하지 않음
        replaceStr += str;
      }

      return replaceStr.toString(); //	let를 문자열형으로 리턴
    };

    /**
     * 자동이체일 설정
     * @param String dwkDstcd : 요일구분
     * @param String trsaccDd : 이체일 (이체주기단위구분코드가 월일때 일 (예) 27, 1 ) // => 차기이체일로 변경 
     * @param String trsaccCyclUnitDstcd : 이체주기단위구분코드
     * @param String trsaccCyclUnitCnt : 이체주기단위수
     * @return String : 조합된 자동이체일( 예) 자동이체구분이 주 일경우: "매주 월 요일", 월 일경우 : "매월 27 일")
     */
    Vue.prototype.$setTrsaccCyclDay = function(dwkDstcd, trsaccDd, trsaccCyclUnitDstcd, trsaccCyclUnitCnt) {
      // 요일구분값에 맞는 요일명을 셋팅한다.

      let strChkDate2 =
        dwkDstcd == "1"
          ? this.$t("MPAY-03-01-10-14")
          : dwkDstcd == "2"
          ? this.$t("MPAY-03-01-10-15")
          : dwkDstcd == "3"
          ? this.$t("MPAY-03-01-10-16")
          : dwkDstcd == "4"
          ? this.$t("MPAY-03-01-10-17")
          : dwkDstcd == "5"
          ? this.$t("MPAY-03-01-10-18")
          : dwkDstcd == "6"
          ? this.$t("MPAY-03-01-10-19")
          : dwkDstcd == "7"
          ? this.$t("MPAY-03-01-10-20")
          : "";

      if(strChkDate2 == ""){
        strChkDate2 = this.$t("MPAY-03-01-10-14");
      }
      console.log("요일구분: " + dwkDstcd + "//" + "몇 일: " + trsaccDd +" // 무슨 요일 : " + strChkDate2);
      let tranFeqDesc;

      if (trsaccCyclUnitDstcd == "2") {
        tranFeqDesc =
          trsaccCyclUnitCnt == "1"
            ? this.$t("MPAY-03-01-10-09", { 1: strChkDate2 }) //매주 {1}요일
            : trsaccCyclUnitCnt == "2"
            ? this.$t("MPAY-03-01-10-10", { 1: strChkDate2 }) //2주 후 {1}요일
            : trsaccCyclUnitCnt == "3"
            ? this.$t("MPAY-03-01-10-11", { 1: strChkDate2 }) //3주 후 {1}요일
            : trsaccCyclUnitCnt == "4"
            ? this.$t("MPAY-03-01-10-12", { 1: strChkDate2 }) //4주 후 {1}요일
            : "";

      } else if (trsaccCyclUnitDstcd == "3") {
        // 매월 차기 이체일로 선택한 날짜
        tranFeqDesc = this.$t("MPAY-03-01-10-13", { 1: this.$t(trsaccDd) }); //매월 {1}일

      }


      
      return tranFeqDesc;
    };

    Vue.prototype.$fildDown = function(obj) {
      const url =
        "/commonbiz/file/comFilefiledown?name=" +
        encodeURIComponent(obj.PsyclFileName.trim()) +
        "&path=" +
        encodeURIComponent(obj.FilePathName.trim()) +
        "&realname=" +
        encodeURIComponent(obj.LogicFileName.trim());
      const fileNm = obj.LogicFileName;

      return {
        path: url,
        filename: fileNm,
      };
    };
    /**
     * 전화 키패드로 전환
     * @param String 키패드로 옮기고 싶은 전화번호
     */
    Vue.prototype.$goToTel = function(telNum) {
      location.href = "tel:" + telNum;
    };
    /**
     * 메일 기능으로 전환
     * @param String 보내고 싶은 mail 링크
     */
    Vue.prototype.$goToMail = function(mailLink) {
      location.href = "mailto:" + mailLink;
    };
    /**
     * 안드로이드는 구글
     * @param String smphMchtlDstcd 안드로이드와 IOS 구별 구분자(NativeAll에서 가져와야함)
     */
    Vue.prototype.$goToMarket = function(smphMchtlDstcd) {
      switch (smphMchtlDstcd) {
        case this.$config.OS_ANDROID:
          location.href = Vue.prototype.$config.MARKET_ANDROID
          break;
        case this.$config.OS_IOS:
          this.$bridge.goAppleStore();
          break;
      }
    };

    /**
     * 바이트 길이 계산
     * @param {*} s 계산할 문자열
     */
    Vue.prototype.$getByteLength = function(s, b, i, c) {
      for (b = i = 0; (c = s.charCodeAt(i++)); b += c >> 11 ? 3 : c >> 7 ? 2 : 1);
      return b;
    };

    /**
     * html encode
     * encode('< ©', {mode: 'nonAsciiPrintable'});
     * // -> &lt; &copy;
     */
    Vue.prototype.$htmlEncode = function(v) {
      return encode(v, { mode: "nonAsciiPrintable" });
    };

    /**
     * html decode
     * decode('&lt; &gt; &quot; &apos; &amp; &#169; &#8710;');
     * // -> < > " \' & © ∆
     */
    Vue.prototype.$htmlDecode = function(v) {
      return decode(v, { mode: "nonAsciiPrintable" });
    };

    /**
     * 유틸 함수 모음
     */
    Vue.prototype.$utils = function() {
      return {
        Router: {
          /**
           * 쿼리 스트링 추출
           *
           * e.g )
           *
           *  k = "abc"
           *
           * 결과 )
           *
           *  // 샘플 URL- http://localhost:8080?abc=1&def=2
           *  return 1
           */
          extractQueryStringByKey(k) {
            const currentUrl = window.location.href;
            const queryStringStartIndex = currentUrl.indexOf("?");
            return new URLSearchParams(queryStringStartIndex > -1 ? currentUrl.substr(queryStringStartIndex, currentUrl.length - 1) : "").get(k);
          },
          /**
           * 순수 URL만 추출
           *
           * e.g )
           *
           *  // http://localhost:8080?abc=1&def=2
           *  return http://localhost:8080
           *
           *  // http://localhost:8080/a/b/c
           *  return http://localhost:8080/a/b/c
           *
           *	// http://kbstar.com
           *	return http://kbstar.com
           */
          extractPureUrl(v) {
            const currentUrl = v;
            const queryStringStartIndex = currentUrl.indexOf("?");
            return queryStringStartIndex > -1 ? currentUrl.substr(0, queryStringStartIndex) : currentUrl;
          },
        },
        Array: {
          has(v) {
            // 값이 `null`이나 `undefined`이면 값이 없다고 판단
            if (!v) {
              return false;
            }
            // 데이터 타입이 `Array` 타입이 아닌 경우에도 값이 없다고 판단
            if (!_.isArray(v)) {
              return false;
            }

            return v.length > 0;
          },
          empty(v) {
            // 값이 `null`이나 `undefined`이면 값이 비어있다고 판단
            if (!v) {
              return true;
            }
            // 데이터 타입이 `Array` 타입이 아닌 경우에도 값이 비어있다고 판단
            if (!_.isArray(v)) {
              return true;
            }

            return v.length === 0;
          },
          remove(array, index) {
            const remove = (element, eIndex) => eIndex != index;
            return array.filter(remove);
          },
        },
        Generator: {
          /**
           * UUID 만들기
           */
          createUuid() {
            return uuid.v4();
          },
          /**
           * 오브젝트에서 값 추출
           *
           * e.g )
           *
           *  source: {
           *    "a": 1,
           *    "b": 2,
           *    "c": 3,
           *  }
           *
           *  keys: [
           *    "a", undefined, null, "", "c"
           *  ]
           *
           *  결과 )
           *
           *  {
           *    "a": 1, "c": 3
           *  }
           */
          extractObject(source, keys) {
            const v = _.isNil(keys) || keys.length === 0 ? Object.keys(source) : keys.filter(k => _.negate(_.isNil)(k));

            return v.reduce((a, b) => {
              const fv = _.get(source, b);
              return _.negate(_.isUndefined)(fv) ? (a = _.merge(a, { [b]: fv })) : a;
            }, {});
          },
          /**
           * 오브젝트 키 이름 변경
           *
           * e.g )
           *
           *  source : {
           *   "a": 1
           *  }
           *
           *  target : [
           *   ...
           *   {
           *     before: "a"
           *     after: "b"
           *   }
           *   ...
           *  ]
           *
           *  결과 )
           *
           *  {
           *    "b": 1
           *  }
           */
          renameObjectKeys(source, target) {
            if (_.isNil(source)) return source;
            if (_.isNil(target) || target.length === 0) return source;

            const v = target.filter(k => {
              return _.negate(_.isNil)(k) && _.negate(_.isNil)(k.before) && _.negate(_.isNil)(k.after);
            });

            return v.reduce((a, b) => {
              const fv = _.get(source, b.before);
              return _.negate(_.isUndefined)(fv) ? (a = _.merge(a, { [b.after]: fv })) : a;
            }, {});
          },
          /**
           * 문자열을 하나씩 잘라서 배열로 만들기
           *
           * e.g )
           *
           *  v = "abcdefg";
           *
           * 결과 )
           *  [
           *    "a", "b", "c", "d", "e", "f", "g"
           *  ]
           */
          splitStringsOneByOne(v) {
            const arr = [];
            for (let i = 0; i < v.length; i++) {
              arr.push(v.charAt(i));
            }
            return arr;
          },
          /**
           * 문자하나에 대한 코드값을 반환해준다
           *
           * e.g )
           *
           * 숫자인 경우
           *  v = "1";
           * 결과 )
           *  return "0001-057"
           *
           * --
           *
           * 알파벳(소문자)인 경우
           *  v = "a";
           * 결과 )
           *  return "0001-207"
           *
           * --
           *
           * 알파벳(대문자)인 경우
           *  v = "A";
           * 결과 )
           *  return "0001-207"
           *
           * --
           *
           * 예외 결과는 공백으로 반환한다
           */
          getNumberOrAlphabetCode: v => {
            if (_.isNil(v)) {
              return "";
            }
            if (_.negate(_.isString)(v)) {
              return "";
            }
            if (v.trim().length !== 1) {
              return "";
            }

            if (/[0-9]/.test(v)) {
              return "0701-057";
            } else if (/[a-z]/.test(v)) {
              return "0001-207";
            } else if (/[A-Z]/.test(v)) {
              return "0001-207";
            } else {
              return "";
            }
          },
        },
        Converter: {
          /**
           * 3자리마다 `,` 추가
           *
           * e.g )
           *  n = 63456453345
           *
           * 결과 )
           *  63,456,453,345
           */
          numberWithCommas(n) {
            return n ? n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : n;
          },
        },
        String: {
          /**
           * v - 확인할 값
           * d - 기본 값
           */
          evl(v, d) {
            return _.isNil(v) ? d : String(v);
          },
        },
        Integer: {
          parseInt(v) {
            return _.toNumber(v);
          },
        },
      };
    };

    /**
     * Extracting Bank Branch No
     */
    Vue.prototype.$getBnkBrnNo = function() {
      return {
        MM2: {
          ruleSet: [
            { name: "AGDBMMMY", no: 5, option: "" },
            { name: "AYFDMMMY", no: 4, option: "" },
            { name: "CPOBMMMY", no: 4, option: "" },
            { name: "KBZBMMMY", no: 3, option: "" },
            { name: "MMABMMMY", no: 3, option: "" },
            { name: "UABMMMMY", no: 3, option: "" },
            { name: "YOMAMMMY", no: 4, option: "" },
          ],

          getBranchNo(bankNo, acno) {
            let brnNo = "";
            let rule = _.filter(this.ruleSet, { name: bankNo });

            if (_.isEmpty(rule)) return "";

            for (let i = 0; i < rule[0].no; i++) {
              brnNo = brnNo + acno.charAt(i);
            }

            return rule[0].option + brnNo;
          },
        },
      };
    };

    Vue.prototype.$auth = {
      // fido 상태코드 확인(정상으로 사용할수 있는경우만 사용가능으로 리턴 함)
      getFidoStatus: function(fidoid, s1, s2, sp, sf, fidoInfoArr) {
        let result = {
          isPincode: "0",
          isFingerprint: "0",
        };

        fidoInfoArr.length > 0 &&
          fidoInfoArr.forEach(e => {
            if (e.userName === fidoid && e.isPincode === "1" && s1 === s2 && sp === "0") {
              result.isPincode = "1";
            }

            if (e.userName === fidoid && e.isFingerprint === "1" && s1 === s2 && sf === "1") {
              result.isFingerprint = "1";
            }
          });
        return result;
      },
      // fido 상태코드 확인(발급여부를 리턴 함 - 상태값은 확인하지 않음)
      getFidoStatusForLogin: function(fidoid, s1, s2, sp, sf, fidoInfoArr) {
        let result = {
          isPincode: "0",
          isFingerprint: "0",
        };

        fidoInfoArr.length > 0 &&
          fidoInfoArr.forEach(e => {
            if (e.userName === fidoid && e.isPincode === "1" && s1 === s2 && (sp === "0" || sp === "1")) {
              result.isPincode = "1";
            }

            if (e.userName === fidoid && e.isFingerprint === "1" && s1 === s2 && sf === "1") {
              result.isFingerprint = "1";
            }
          });
        return result;
      },
    };
  },
};
